<template>
  <div class="history-switcher">
    <div class="title">
      <span></span>
    </div>
    <div class="drop">
      <ul class="list">
        <li
          class="item"
          v-for="(item, i) in items"
          :key="i"
          @click="setItem({item, index: i})"
        >{{item.name}}</li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      currentIndex: 0,
      items: [
        { name: '版本记录', type: 'version' },
        { name: '项目备份', type: 'backup' }
      ]
    }
  },
  computed: {
    currentItem () {
      return this.items[this.currentIndex]
    }
  },
  methods: {
    setItem ({
      item,
      index
    } = {}) {
      this.$emit('clickItem', { item });
      if (this.currentIndex === index) {
        return;
      }
      this.currentIndex = index;
    }
  }
}
</script>

<style lang="scss" scoped>
.history-switcher {
  position: relative;
  & > .title {
    background: rgba(242,243,247,1);
  }
  &:hover {
    & > .drop {
      display: block;
    }
  }
}
.title {
  width: 52px;
  height: 36px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: space-around;
  color: #474261;
  line-height: 36px;
  padding-left: 10px;
  padding-right: 10px;
  & > span {
    flex-shrink: 0;
    display: inline-block;
    width: 16px;
    height: 16px;
    margin-right: 10px;
    background-image: url(../../../static/svg/topNav/versionHistory.svg);
    background-repeat: no-repeat;
  }
  &:after {
    // position: absolute;
    content: '';
    width: 0;
    height: 0;
    top: 15px;
    right: 10px;
    border-width: 6px 6px 0;
    border-style: solid;
    border-color: #474261 rgba(0, 0, 0, 0) rgba(0, 0, 0, 0) rgba(0, 0, 0, 0);
  }
}
.drop {
  display: none;
  position: absolute;
  top: 100%;
  width: 112px;
}
.list {
  margin-top: 4px;
  width: 112px;
  background: #fff;
  box-shadow: 0px 0px 4px 0px rgba(54, 76, 204, 0.4);
  border-radius: 4px;
  color: #474261;
}
.item {
  height: 32px;
  width: 100%;
  line-height: 32px;
  &:hover {
    background-color: #f0f0f8;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/topnav/historySwitcher.vue